import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import placeholderQandA from "../data/placeholderQandA";
import pastShows from "../data/pastShows";
import { Link } from "react-router-dom";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
});
// Helper hook to load scripts only once.
const useScript = (url) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${url}"]`)) {
      return;
    }
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
  }, [url]);
};

const Contact = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [activeTab, setActiveTab] = useState("instagram");

  useScript("https://www.tiktok.com/embed.js");
  useScript("https://www.instagram.com/embed.js");

  useEffect(() => {
    if (activeTab === "instagram" && window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [activeTab]);

  const sortedQandA = [...placeholderQandA].sort(
    (a, b) => b.upvotes - a.upvotes
  );

  return (
    <main className="page-content">
      <div className="page-title-container">
        <h1>{t("contactTitle")}</h1>
      </div>

      {/* === Social Media Embed Section (UPDATED LOGIC) === */}
      <section className="contact-page-section">
        <h2>{t("socialTitle")}</h2>
        <div className="social-embed-container">
          <div className="social-tabs">
            <button
              className={activeTab === "instagram" ? "active" : ""}
              onClick={() => setActiveTab("instagram")}
            >
              Instagram
            </button>
            <button
              className={activeTab === "tiktok" ? "active" : ""}
              onClick={() => setActiveTab("tiktok")}
            >
              TikTok
            </button>
          </div>
          <div className="social-content">
            {/* We now render both embeds and use CSS `display` to toggle them. */}
            {/* This prevents React from trying to remove the DOM node. */}
            <div
              style={{ display: activeTab === "instagram" ? "block" : "none" }}
            >
              <blockquote
                className="instagram-media"
                data-instgrm-permalink="https://www.instagram.com/marinoflores_official/?utm_source=ig_embed&utm_campaign=loading"
                data-instgrm-version="14"
                style={{ maxWidth: "100%", minWidth: "98%" }}
              ></blockquote>
            </div>
            <div style={{ display: activeTab === "tiktok" ? "block" : "none" }}>
              <blockquote
                className="tiktok-embed"
                cite="https://www.tiktok.com/@marino_flores_oficial"
                data-unique-id="marino_flores_oficial"
                data-embed-type="creator"
                style={{ maxWidth: "100%", minWidth: "98%" }}
              >
                <section>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.tiktok.com/@marino_flores_oficial?refer=creator_embed"
                  >
                    @marino_flores_oficial
                  </a>
                </section>
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* Other sections remain the same */}
      <section className="contact-page-section">
        <h2>{t("mailingListTitle")}</h2>
        <p className="section-subtitle">{t("mailingListSubtitle")}</p>
        <form className="mailing-list-form">
          <input type="email" placeholder={t("mailingListPlaceholder")} />
          <button type="submit" className="cta-button">
            {t("mailingListButton")}
          </button>
        </form>
      </section>

      <section className="contact-page-section">
        <h2>{t("qnaTitle")}</h2>
        <p className="section-subtitle">{t("qnaSubtitle")}</p>
        <div className="qna-container">
          <form className="qna-form">
            <textarea placeholder={t("qnaFormPlaceholder")}></textarea>
            <button type="submit" className="cta-button">
              {t("qnaSubmitButton")}
            </button>
          </form>
          <div className="qna-list">
            {sortedQandA.map((item) => (
              <div key={item.id} className="qna-item">
                <p className="qna-question">
                  <strong>Q:</strong>{" "}
                  {item[currentLang]?.question || item.en.question}
                </p>
                <p className="qna-answer">
                  <strong>A:</strong>{" "}
                  {item[currentLang]?.answer || item.en.answer}
                </p>
                <div className="qna-upvotes">{item.upvotes} 🔥</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="contact-page-section">
        <h2>{t("pastShowsTitle")}</h2>
        <p className="section-subtitle">{t("pastShowsSubtitle")}</p>
        <div className="map-container">
          <MapContainer
            center={[36.6777, -121.6555]}
            zoom={5}
            scrollWheelZoom={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
              url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
            />
            {pastShows.map((show) => (
              <Marker key={show.id} position={show.position}>
                <Popup>
                  <div className="popup-content">
                    <strong>{show.venue}</strong>
                    <p>
                      {show.city} • {show.date}
                    </p>
                    <p>
                      <strong>{t("packageTypeLabel")}:</strong>{" "}
                      {show.packageType}
                    </p>
                    <Link
                      to={`/gallery/${show.slug}`}
                      className="secondary-button popup-gallery-btn"
                    >
                      {t("viewGalleryButton")}
                    </Link>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </section>
    </main>
  );
};

export default Contact;
